import { Button } from "@/components/ui/button";
import { secondaryButtonClasses } from "@/constants/ui";
import { useMakeABookingDialog } from "../useMakeABookingDialog";
import { CalendarX } from "lucide-react";

/**
 * R1/R2a/R7 — shown instead of the booking form when the TimeSlotClickInterceptor declined the
 * slot click (past date, beyond the role-aware future cap, hard overlap, shuttered room). The
 * member sees the reason and a single Close action; there is no path to create the booking.
 */
export const DeclinedScreen = () => {
  const { declineMessage, onClose } = useMakeABookingDialog();

  return (
    <div className="w-full flex flex-col items-center text-center bg-white rounded-xl my-4 p-8 gap-4">
      <div className="flex items-center justify-center h-14 w-14 rounded-full bg-amber-50">
        <CalendarX className="h-7 w-7 text-amber-600" />
      </div>
      <h2 className="text-2xl font-semibold">Booking not available</h2>
      <p className="text-sm text-gray-600 max-w-md" data-testid="booking-declined">
        {declineMessage}
      </p>
      <Button type="button" variant="outline" className={`mt-2 ${secondaryButtonClasses}`} onClick={() => onClose?.()}>
        Close
      </Button>
    </div>
  );
};

export default DeclinedScreen;
